var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-button',_vm._g(_vm._b({attrs:{"color":"accent","iconI":"mdi-export","menu":_vm.menu,"spantext":_vm.spantext,"text":""},on:{"click":function($event){return _vm.handleExport()}},scopedSlots:_vm._u([{key:"name",fn:function(){return [_vm._v(" "+_vm._s(_vm.name)+" ")]},proxy:true}])},'avs-button',{ ..._vm.$attrs },false),{ ..._vm.$listeners }))
}
var staticRenderFns = []

export { render, staticRenderFns }